<div class="flex min-w-0 flex-auto flex-col">
  <!-- Main Content -->
  <div class="flex-auto p-6 sm:p-10">
    <app-breadcrumb></app-breadcrumb>
    <!-- Table Title and Actions -->
    <div class="rounded-2xl">
      <div class="text-4xl font-extrabold tracking-tight flex m-5">
        <h1 class="text-4xl font-extrabold tracking-tight">Users</h1>

        <mat-form-field class="w-3/12 ml-4">
          <input
            matInput
            placeholder="Search"
            [formControl]="searchForm.get('search')"
            (keyup)="onSearch($event)"
          />
          <button mat-icon-button matSuffix aria-label="Search">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field class="w-2/12 ml-4">
          <mat-select
            [(ngModel)]="selectedStatus"
            (ngModelChange)="onStatusChange($event)"
            placeholder="Vendor Status"
          >
            <mat-option value="">Select status</mat-option>

            <mat-option *ngFor="let status of userStatusList" [value]="status">
              {{ status | titlecase }}
            </mat-option>
          </mat-select></mat-form-field
        >
        <button
          [disabled]="!hasDetailedPerm('User_Management', 'Create', 'read')"
          class="ms-auto app-button"
          mat-flat-button
          (click)="createUser()"
        >
          <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
          <span class="ml-2 mr-1">Create User</span>
        </button>
      </div>

      <!-- Material Table -->
      <div
        class="mat-elevation-z8 mx-5 bg-white h-[calc(100vh-350px)] overflow-auto"
      >
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)" class="  ">
          <ng-container matColumnDef="serial">
            <th mat-header-cell *matHeaderCellDef class="text-nowrap">Sr. No.</th>
            <td mat-cell *matCellDef="let role; let i = index">
              {{ i + 1 + pagination.page * pagination.limit }}
            </td>
          </ng-container>

          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-nowrap">Username</th>
            <td mat-cell *matCellDef="let user">
              <span class="inline-flex items-center gap-1">
                {{ user.username }}
                <mat-icon
                  *ngIf="user.userType === 'sub-admin'"
                  class="icon-size-4 !text-[#8b2424]"
                  matTooltip="Sub-admin access"
                  matTooltipPosition="above"
                  >admin_panel_settings</mat-icon>
              </span>
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-nowrap">
              First Name
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.firstName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-nowrap">Last Name</th>
            <td mat-cell *matCellDef="let user">{{ user.lastName }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-nowrap">Email</th>
            <td mat-cell *matCellDef="let user">
              <span
                class="block max-w-[200px] truncate"
                [matTooltip]="user.email"
                matTooltipPosition="above"
              >
                {{ user.email }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef class="text-nowrap">Role</th>
            <td mat-cell *matCellDef="let user" class="text-nowrap">
              {{ user.role }}
            </td>
          </ng-container>

          <!-- Modular Permission Column -->
          <!-- <ng-container matColumnDef="modularPermission">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Modular Permission </th>
                        <td mat-cell *matCellDef="let role"> {{ role.modularPermission.join(', ') }} </td>
                    </ng-container> -->

          <!-- Functional Permission to Add Column -->
          <!-- <ng-container matColumnDef="functionalPermissionToAdd">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Functional Permission to Add </th>
                        <td mat-cell *matCellDef="let role"> {{ role.functionalPermissionToAdd.join(', ') }} </td>
                    </ng-container> -->

          <!-- Functional Permission to Update Column -->
          <!-- <ng-container matColumnDef="functionalPermissionToUpdate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Functional Permission to Update </th>
                        <td mat-cell *matCellDef="let role"> {{ role.functionalPermissionToUpdate.join(', ') }} </td>
                    </ng-container> -->

          <!-- Functional Permission to Delete Column -->
          <!-- <ng-container matColumnDef="functionalPermissionToDelete">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Functional Permission to Delete </th>
                        <td mat-cell *matCellDef="let role"> {{ role.functionalPermissionToDelete.join(', ') }} </td>
                    </ng-container> -->

          <!-- Other Functional Permission Column -->
          <!-- <ng-container matColumnDef="otherFunctionalPermission">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Other Functional Permission </th>
                        <td mat-cell *matCellDef="let role"> {{ role.otherFunctionalPermission.join(', ') }} </td>
                    </ng-container> -->

          <!-- Action Column (for Edit/Delete buttons) -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let user">
              <span class="px-2 rounded-full {{ getBadgeClass(user.status) }}">
                {{ user.status | titlecase }}</span
              >
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let user" class="text-nowrap">
              <button mat-icon-button color="accent" (click)="viewDetail(user)">
                <mat-icon>remove_red_eye</mat-icon>
              </button>
              <button
                [disabled]="
                  !hasDetailedPerm('User_Management', 'Edit', 'read')
                "
                mat-icon-button
                (click)="editRole(user)"
              >
                <mat-icon>edit</mat-icon>
              </button>

              <button
                *ngIf="user.status !== 'archived'"
                mat-icon-button
                matTooltip="Archive user"
                matTooltipPosition="above"
                (click)="deleteUser(user)"
                [disabled]="!hasDetailedPerm('User_Management', 'Delete', 'read')"
              >
                <mat-icon class="app-text">archive</mat-icon>
              </button>

              <button
                *ngIf="user.status === 'archived'"
                mat-icon-button
                matTooltip="Unarchive user"
                matTooltipPosition="above"
                (click)="deleteUser(user, false)"
              >
                <mat-icon class="app-text">unarchive</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Table Header and Rows -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <!-- Paginator -->
      </div>
      <div class="flex justify-end bg-white mx-5">
        <mat-paginator
          [length]="pagination.length"
          [pageSize]="10"
          [pageIndex]="pagination.page"
          [pageSizeOptions]="[5, 10, 25, 100]"
          class=""
          (page)="onPaginateChange($event)"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
